import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketTemp`;


const ApiBasketTemp = {
  getAllBasketTemp: (params) => {
    const url = `${baseServiceUrl}/getAllBasketTemp`;
    return ServiceApi.get(url, { params });
  },

  // getBasketCanceledOrder: (params) => {
  //   const url = `${baseServiceUrl}/getAllCanceledOrder`;

  //   return ServiceApi.get(url, { params });
  // },
  // get: (id) => {
  //   const url = `${baseServiceUrl}/${id}`;
  //   return ServiceApi.get(url);
  // },
  // getBasketPayment: (params) => {
  //   const url = `${baseServiceUrl}/getBasketPayment`;
  //   return ServiceApi.get(url, { params });
  // },
  createBasketTemp: (params) => {
    const url = `${baseServiceUrl}/createBasketTemp`;
    return ServiceApi.post(url, params);
  },
  createItemBasket: (params) => {
    const url = `${baseServiceUrl}/addOrEditeBasketTemp`;
    return ServiceApi.post(url, params);
  },
  // changeBasketItemPersonCancelStatus: (params) => {
  //   const url = `${baseServiceUrl}/changeBasketItemPersonCancelStatus`;
  //   return ServiceApi.put(url,params);
  // },
  getBasketTempById: (params) => {
    const url = `${baseServiceUrl}/getBasketTempById?id=` + params;
    return ServiceApi.get(url);
  },
  // GetCanceldBasketById: (id) => {
  //   const url = `${baseServiceUrl}/GetCanceldBasketById?basketId=`+id;
  //   return ServiceApi.get(url);
  // },
  // update: ( data) => {
  //   const url = `${baseServiceUrl}/ChangeBasketItemPersonCurrentStatus`;
  //   return ServiceApi.put(url, data);
  // },
  // updatePersons: ( data) => {
  //   const url = `${baseServiceUrl}/CreateUpdateBasketItemPerson`;
  //   return ServiceApi.put(url, data);
  // },
  deleteBasketItemPersonTemp: (params) => {
    const url = `${baseServiceUrl}/DeleteBasketItemPersonTemp`;
    return ServiceApi.post(url, params);
  },

};

export default ApiBasketTemp;


